'use client';

import { Suspense } from 'react';

import { AuthLayout } from '@/components/Layout/AuthLayout';
import { LoadingOverlay } from '@/components/Load/loading-overlay';

import { LoginForm } from './components/LoginForm';

export default function LoginPage() {
  return (
    <AuthLayout title="ログイン" subTitle="" description="">
      <Suspense fallback={<LoadingOverlay isLoading={true} />}>
        <LoginForm />
      </Suspense>
    </AuthLayout>
  );
}
